import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const anshinpack = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜ハロー安心保証パックをご紹介';
  return (
    <div className="container">
      {breadcrumbs(type, [
        { text: " ハロー安心保証パックをご紹介" },
      ])}
      
      <div className="anshinpack">
        <h2 id="contentsHead">ハロー安心保証パック</h2>
        <div className="my30 mw900">
          <div className="clearfix">
            <p className="textCenter">
              <img
                src="resource/img/static/anshinpack/anshin_logo2019.jpg?20210617"
                width="750"
                height="300"
                alt="ハロー安心保証パックロゴ"
              />
            </p>
            <p className="mt30 textCenter">
              <img
                src="resource/img/static/anshinpack/anshin_free.jpg?1533085820"
                width="750"
                height="80"
                alt="下記の対応がすべて無料になります。"
              />
            </p>
            <p className="mt20 textCenter">
              <img
                src="resource/img/static/anshinpack/anshin_rei.jpg?20210617"
                width="750"
                height="430"
                alt="通常の対応料金"
              />
            </p>
            <p className="textCenter">
              <img
                src="resource/img/static/anshinpack/anshin_hayami.jpg?20210617"
                width="750"
                height="160"
                alt="月額料金"
              />
            </p>
            <p className="mt30 anshinCaution">
              <span>※注意事項</span>
            </p>
            <ol className="anshinOl">
              <li>表記はすべて税込み価格となります。 </li>
              <li>緊急対応については、別途金１６，５００円をいただきます。</li>
              <li>保証回数は契約日より起算いたします。</li>
              <li>
                お客様の故意または重過失が認められた場合には、保証が受けられないこともございます。
              </li>
              <li>
                原状復帰に伴う修繕費用が発生した場合は、別途請求することがございます。
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/anshinpack.jsx